module.exports = __webpack_public_path__ + "img/tpc-brochures-1.e4cad863.webp";